module.exports = __webpack_public_path__ + "static/media/blurred-background-bouquet-bridal-948185.d3c7ec6f.jpg";